import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { fetch } from 'Api/myCoursesPage';

const useFetch = setIsLoading => {
  const [courses, setCourses] = useState([]);
  const [category, setCategory] = useState(null);
  const [name, setName] = useState(null);
  const [categories, setCategories] = useState([]);
  const [isCard, setIscard] = useState(true);
  const history = useHistory();

  useEffect(() => {
    let isMounted = true;
    const newCategory = category === '' ? null : category;

    if (isMounted) {
      fetch({ category: newCategory, name }).then(data => {
        setCourses(data?.courses?.filter(course => course[course.length - 2] !== true));
        setCategories(data.categories);
      });
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
      setCourses([]);
      setCategory(null);
      setName(null);
      setCategories([]);
      setIscard(true);
    };
  }, [category, name]);

  const sendToCourseDetails = (course, colorCategory) => {
    history.push({
      pathname: '/cursos/detalles',
      state: {
        update: true,
        course,
        colorCategory,
        isComingFrom: '/mis-cursos',
      },
    });
  };

  return {
    courses,
    categories,
    setCategory,
    setName,
    setIscard,
    isCard,
    sendToCourseDetails,
  };
};

export default useFetch;
